import React, { createContext, useState, useContext } from 'react';

// Create Context
const LocationContext = createContext();

// Custom Hook for Using Context
export const useLocation = () => useContext(LocationContext);

// Provider Component
export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState({
    city: localStorage.getItem('city') || 'Select Location',
    lat: localStorage.getItem('latitude') || null,
    lng: localStorage.getItem('longitude') || null,
  });

  const updateLocation = (city, lat, lng) => {
    setLocation({ city, lat, lng });
    localStorage.setItem('city', city);
    localStorage.setItem('latitude', lat);
    localStorage.setItem('longitude', lng);
  };

  return (
    <LocationContext.Provider value={{ location, updateLocation }}>
      {children}
    </LocationContext.Provider>
  );
};